import { combineReducers } from "redux"
import user from "./reducers/user"
import order from "./reducers/order"
import modal from "./reducers/modal"
import category from "./reducers/category"

export default combineReducers({ user, order, modal, category })
